export default __webpack_public_path__ + "static/MD_SearchThumb_Cloud_IFTTT-1c59b9c62a2f0050517b54c65e8719cb.webp";